// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.signing.LeaseSigningWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseSigningWebApiHandler_cancelSigning,
  LeaseSigningWebApiHandler_sendForOfflineSigning,
  LeaseSigningWebApiHandler_sendForOnlineSigning,
} from '@zg-rentals/ts-leasing-client';

import type {
  CancelSigningRequestDto,
  SendForOfflineSigningRequestDto,
  SendForOnlineSigningRequestDto,
} from '@zg-rentals/ts-leasing-client';

export interface LeaseSigningWebApiHandler_cancelSigning_Args {
  postData: CancelSigningRequestDto;
}

export type LeaseSigningWebApiHandler_cancelSigning_Options = UseMutationOptions<
  void,
  unknown,
  LeaseSigningWebApiHandler_cancelSigning_Args
>;

/**
 * cancels signing for a lease that is currently in a signing state
 */
export const useLeaseSigningWebApiHandler_cancelSigning = ({
  httpClient,
  ...options
}: Omit<LeaseSigningWebApiHandler_cancelSigning_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseSigningWebApiHandler_cancelSigning_Args) =>
      LeaseSigningWebApiHandler_cancelSigning(args.postData, httpClient),
  });
};

export interface LeaseSigningWebApiHandler_sendForOfflineSigning_Args {
  postData: SendForOfflineSigningRequestDto;
}

export type LeaseSigningWebApiHandler_sendForOfflineSigning_Options = UseMutationOptions<
  void,
  unknown,
  LeaseSigningWebApiHandler_sendForOfflineSigning_Args
>;

/**
 * sends the lease for offline signing
 */
export const useLeaseSigningWebApiHandler_sendForOfflineSigning = ({
  httpClient,
  ...options
}: Omit<LeaseSigningWebApiHandler_sendForOfflineSigning_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseSigningWebApiHandler_sendForOfflineSigning_Args) =>
      LeaseSigningWebApiHandler_sendForOfflineSigning(args.postData, httpClient),
  });
};

export interface LeaseSigningWebApiHandler_sendForOnlineSigning_Args {
  postData: SendForOnlineSigningRequestDto;
}

export type LeaseSigningWebApiHandler_sendForOnlineSigning_Options = UseMutationOptions<
  void,
  unknown,
  LeaseSigningWebApiHandler_sendForOnlineSigning_Args
>;

/**
 * transitions the lease into the sent for online signing state and sends appropriate emails
 */
export const useLeaseSigningWebApiHandler_sendForOnlineSigning = ({
  httpClient,
  ...options
}: Omit<LeaseSigningWebApiHandler_sendForOnlineSigning_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseSigningWebApiHandler_sendForOnlineSigning_Args) =>
      LeaseSigningWebApiHandler_sendForOnlineSigning(args.postData, httpClient),
  });
};
